/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RetryDisputeRefundData = {
    bookingId: string;
    disputeId: string;
    refundId: string;
    refundStatus: RetryDisputeRefundData.refundStatus;
};
export namespace RetryDisputeRefundData {
    export enum refundStatus {
        INITIATED = 'initiated',
    }
}

